export const ALL_PRODUCTS_GRAPHQL_QUERY = `
{
  products(first: 100, query: "status:active") {
    edges {
      node {
        id
        title
        productType: metafield(namespace: "custom", key: "product_type") {
          value
        }
        description
        variants(first: 30) {
          edges {
            node {
              id
              sku: metafield(namespace: "custom", key: "product_id") {
                value
              }
              options: selectedOptions {
                name
                value
              }
              product {
                description
              }
              image {
                url
                height
                altText
                width
                src
                transformedSrc
                originalSrc
                id
              }
              priceV2 {
                amount
                currencyCode
              }
              compareAtPriceV2 {
                amount
                currencyCode
              }
            }
          }
        }
        images(first: 10) {
          edges {
            node {
              url
              height
              altText
              width
              src
              transformedSrc
              originalSrc
              id
            }
          }
        }
        priceRange {
          minVariantPrice {
            amount
          }
          maxVariantPrice {
            amount
          }
        }
      }
    }
  }
}
`;
